import { formatPortalDateTime } from "utils/formatters";

export const buildQueryString = (filters = {}) => {
    const searchParams = new URLSearchParams();
  
    Object.entries(filters).forEach(([key, value]) => {
      if (
        value === null ||
        value === undefined ||
        value === ""
      ) {
        return;
      }
  
      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== "") {
            searchParams.append(key, item);
          }
        });
  
        return;
      }
  
      searchParams.append(key, value);
    });
  
    return searchParams.toString();
  };

  export const nonEmptyStr = (v, fallback = "—") => {
    if (v === null || v === undefined || v === "") return fallback;
    return String(v).trim();
  };

  /** @deprecated Prefer `formatPortalDateTime` from `utils/formatters`. */
  export const formatTs = (value) => formatPortalDateTime(value);